export default {"src":"/_next/static/media/landscape-architecture-grid-drawing.a900080c.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};